import React from 'react';
import { useSelector } from "react-redux";
import { selectCurrentUser } from "@shared/store/auth.duck";
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { AddTeamMemberButton } from '@shared/ui/atoms/buttons/AddTeamMemberButton';

export function AddTeamMember(props: Props) {
  const currentUser = useSelector(selectCurrentUser);
  return (
    <Column className={`addTeamMember ${props.className ?? ''}`.trim()} >
      <AddTeamMemberButton team={currentUser?.teamEntity} buttonStyle={'primary'} />
    </Column>
  )
}

interface Props {
  className?: string;
}
